module.exports = {
    showFlowbiteModal(modalInstance, modalId, buttonEl = null) {
        if (modalId.startsWith('#')) {
            modalId = modalId.substring(1); // Remove the hash symbol from the start
        }
        $(document).trigger('modalShown', [modalId, buttonEl]);
        modalInstance._targetEl.classList.add('tw-flex');
        modalInstance._targetEl.classList.remove('tw-hidden');
        modalInstance._targetEl.classList.remove('hidden');
        modalInstance._targetEl.setAttribute('aria-modal', 'true');
        modalInstance._targetEl.setAttribute('role', 'dialog');
        modalInstance._targetEl.removeAttribute('aria-hidden');
        modalInstance._createBackdrop();
        modalInstance._isHidden = false;
        // Add keyboard event listener to the document
        if (modalInstance._options.closable) {
            modalInstance._setupModalCloseEventListeners();
        }
        // prevent body scroll
        document.body.classList.add('tw-overflow-hidden');
        // callback function
        modalInstance._options.onShow(modalInstance);
    },
    hideFlowbiteModal(modalInstance, modalId) {
        if (modalId.startsWith('#')) {
            modalId = modalId.substring(1); // Remove the hash symbol from the start
        }
        modalInstance._targetEl.classList.add('tw-hidden');
        modalInstance._targetEl.classList.add('hidden');
        modalInstance._targetEl.classList.remove('tw-flex');
        modalInstance._targetEl.setAttribute('aria-hidden', 'true');
        modalInstance._targetEl.removeAttribute('aria-modal');
        modalInstance._targetEl.removeAttribute('role');
        modalInstance._destroyBackdropEl();
        modalInstance._isHidden = true;
        // re-apply body scroll
        document.body.classList.remove('tw-overflow-hidden');
        if (modalInstance._options.closable) {
            modalInstance._removeModalCloseEventListeners();
        }
        // callback function
        modalInstance._options.onHide(modalInstance);
    },
    initFlowbiteModal(modalId, $triggerEl = null, options = {}) {
        if (modalId.startsWith('#')) {
            modalId = modalId.substring(1); // Remove the hash symbol from the start
        }

        let $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            // options with default values
            const _options = {
                placement: 'center',
                backdrop: 'dynamic',
                backdropClasses: 'tw-bg-gray-900/50 dark:tw-bg-gray-900/80 tw-fixed tw-inset-0 tw-z-40',
                closable: true,
                onHide: () => {},
                onShow: () => {},
                onToggle: () => {},
                ...options,
            };

            // instance options object
            let instanceOptions = {
                id: modalId,
                override: true,
            };

            // check for existing modal instance
            let existingModal = FlowbiteInstances.instanceExists('Modal', modalId);

            // creates a new instance of the modal or use existing one if it already exists
            let modalInstance = existingModal ? FlowbiteInstances.getInstance('Modal', modalId) : new Modal($modalEl, _options, instanceOptions);

            if (modalInstance) {
                // Attach click event to the buttons
                if ($triggerEl) {
                    $triggerEl.addEventListener('click', () => showFlowbiteModal(modalInstance, modalId, $($triggerEl)));
                }
                document.querySelectorAll('[data-modal-hide="' + modalId + '"]').forEach(($triggerHideEl) => {
                    $triggerHideEl.addEventListener('click', (e) => {
                        hideFlowbiteModal(modalInstance, modalId);
                    });
                });

                modalInstance.updateOnHide(() => {
                    $(document).trigger('modalHidden', [modalId]);
                });
            }
        }
    },
    initializeFlowBiteModals() {
        // Dynamically add data attributes to template modal
        const modalElementTemplate = document.getElementById('templateModal');
        const modalTriggerTemplate = document.querySelector('[data-modal-toggle="templateModal"]');
        if (modalElementTemplate && modalTriggerTemplate) {
            // Add Flowbite data attributes
            const headerBtn = document.getElementById('hideTemplateModalHeaderButton');
            const mainBtn = document.getElementById('hideTemplateModalMainButton');
            headerBtn.setAttribute('data-modal-hide', 'templateModal');
            mainBtn.setAttribute('data-modal-hide', 'templateModal');
        }

        // loops through all modals and initializes them
        document.querySelectorAll('[data-modal-toggle]').forEach(($triggerEl) => {
            let modalId = $triggerEl.getAttribute('data-modal-toggle');
            initFlowbiteModal(modalId, $triggerEl);
        });
    },
};
